import { PageSection } from "../components/Page.js";
import { SettingsEditor } from "../components/settings/SettingsEditor.js";
import { TariffsPanel } from "../components/settings/TariffsPanel.js";

/**
 * The settings view: the instance settings, then the tariff table.
 *
 * The form itself lives in `components/settings/SettingsEditor.tsx`, because
 * the header's settings dialog shows exactly the same one. The tariffs are
 * here only; they are a list that grows, not a dialog's worth of fields.
 */
export function SettingsPage({
  canWrite,
  tariffs,
}: {
  canWrite: boolean;
  /** What the reader may do with the tariff table; null hides it. */
  tariffs: { canWrite: boolean } | null;
}) {
  return (
    <div className="flex flex-col gap-5">
      <PageSection title="Settings">
        <SettingsEditor canWrite={canWrite} />
      </PageSection>
      {tariffs !== null && (
        <PageSection title="Tariffs">
          <TariffsPanel canWrite={tariffs.canWrite} />
        </PageSection>
      )}
    </div>
  );
}
